import { actionCopyEn } from "./actionCopy";

export const diaryCopyEn = {
    diaries: "Diaries",
    diary: "Diary",
    diaryPeriod: "Diary period",
    toDo: "To Do",
    results: "Results",
    toNow: "- Now",
    edit: actionCopyEn.edit,
    change: "Change",
    details: "Details",
    deleteEntry: "Delete entry",
    done: actionCopyEn.done,
    next: actionCopyEn.next,
    save: actionCopyEn.save,
    saving: actionCopyEn.saving,
    cancel: actionCopyEn.cancel,
    date: "Date",
    time: "Time",
    noSteps: "No steps.",
    step: "Step",
    chooseStep: "Choose a step",
    currently: "Currently",
    general: "General",
    procedureDetails: "Procedure details",
    hospitalReferenceNumber: "Hospital reference number",
    hospitalNumber: "Hospital Number",
    hospitalNumberDescription: "Hospital reference number for all trackers.",
    enterHospitalNumber: "Enter hospital number",
    startDate: "Start Date",
    procedureDate: "Procedure date",
    referenceDate: "Reference Date",
    referenceDateDescription: "The date of the injection, surgery or other intervention.",
    baselineDate: "Baseline date",
    baselineDateDescription:
        "The date follow-up is measured from, such as when the patient joined the study. Questionnaires are timed from this date.",
    patientBaselineDate: "Start date",
    patientBaselineDateDescription: "The date your follow-up questions are timed from.",
    eventDateDescription: "Follow-up questionnaires are timed from this date.",
    patientEventDateDescription: "Your follow-up questions are timed from this date.",
    endDate: "End date",
    contactPerson: "Contact Person",
    contactPersonDescription: "Primary contact for this diary. Tap copy to copy their email.",
    loadingContact: "Loading contact...",
    side: "Side",
    anatomicArea: "Anatomic Area",
    questionnaireSide: "Questionnaire side",
    questionnaireSideDescription: "Which side this questionnaire refers to.",
    notSet: "Not set",
    trackerSettings: "Tracker Settings",
    consent: "Consent",
    consentForm: "Consent Form",
    consentDetails: "Details",
    openConsent: "Open consent",
    sign: "Sign",
    signed: "Signed",
    signedAt: (date) => `Signed at ${date}`,
    requiresSignature: "Requires signature",
    actionRequiredSignConsent: "Action Required: Sign Consent",
    signConsentBeforeContinuing: (count) =>
        `You must sign the following consent form${count > 1 ? "s" : ""} before continuing:`,
    signConsentNow: "Sign Consent Now",
    detailsStillNeed: "Details we still need",
    detailsStillNeedDescription:
        "Please complete these details. If side is still missing, we will ask on the setup screen.",
    injectionSide: "Injection side",
    injectionAnatomicArea: "Injection anatomic area",
    surgerySide: "Surgery side",
    shockwaveSide: "Shockwave side",
    shockwaveAnatomicArea: "Shockwave anatomic area",
    yourEntries: "Your entries",
    noDiary: "No Diary",
    noCompletedEntries: "No completed entries yet.",
    form: "form",
    forms: "forms",
    item: "item",
    items: "items",
    questionnaire: "Questionnaire",
    questionnaires: "Questionnaires",
    injection: "Injection",
    surgery: "Surgery",
    shockwave: "Shockwave",
    consultation: "Consultation",
    procedure: "Procedure",
    procedures: (count) => `${count} procedures`,
    task: "task",
    tasks: "tasks",
    toDoEmpty: "You're all caught up - nothing to do right now.",
    blocked: "Waiting on earlier forms",
    blockedEmpty: "No forms are waiting on earlier steps.",
    formsLockedUntilConsentSigned: "Your forms will unlock after you sign the required consent.",
    completePreviousFormFirst: (formName) => `Complete ${formName} first`,
    doneEmpty: "Completed steps will appear here.",
    complete: "Complete",
    due: "Due",
    upToDate: "Up to date",
    allCaughtUp: "All Caught Up",
    formsNeedAttention: "Forms Need Attention",
    progress: "Progress",
    completed: "Completed",
    notNeeded: "Not needed",
    dueNow: "Due now",
    waiting: "Waiting",
    locked: "Locked",
    lockedByEarlierEntry: "Locked - complete an earlier entry first",
    lockedUntilPreviousFormComplete: (formName) => `Locked - complete ${formName} first`,
    availableLater: "Available later",
    nextDue: "Next due",
    dueOn: (date) => `Due ${date}`,
    nextScheduledSentence: (formLabel, scheduleLabel, date) => {
        const schedule = scheduleLabel.trim();
        const due = date.trim();
        const timing = schedule ? ` for ${schedule.toLowerCase()}` : "";
        if (due) return `Your ${formLabel}${timing} is next due on ${due}.`;
        return `Your ${formLabel}${timing} is next due.`;
    },
    noEntriesScheduled: "No entries scheduled yet.",
    showLess: "Show less",
    showMore: (count) => `Show more (${count} more ${count === 1 ? "timing" : "timings"})`,
    showAllTimings: (count) => `Show all ${count} timings`,
    expand: "Expand",
    submitted: (completed, total) => `${completed} of ${total} submitted`,
    submittedOn: (date) => `Submitted ${date}`,
    noDataYet: "No Data Yet",
    noDataDescription: "Start adding entries to see your progress over time",
    notEnoughDataYet: "Not Enough Data Yet",
    notEnoughDataDescription: "To view charts there must be at least two entries.",
    addEntry: "Add Entry",
    addEntryFor: (formSlug, timingLabel) => `Add ${formSlug} ${timingLabel} Entry`,
    addExtraScore: "Add Extra Score",
    addExtraScoreTitle: "Add an extra score",
    addExtraScoreDescription:
        "This is optional. Only continue if you want to record an additional measurement, or you have been asked to check in.",
    addForm: "Add Form",
    entryDue: (label) => `Your entry for ${label.toLowerCase()} is due.`,
    nextEntryDueOn: (label, date) => `Your ${label.toLowerCase()} entry is due on ${date}.`,
    entriesDueForForm: (count) => `${count} entries due for this form.`,
    formWithEntriesDue: (formName, entries) =>
        `${formName} has ${entries} ${entries === 1 ? "entry due" : "entries due"}. Your other forms are up to date.`,
    formsWithEntriesDue: (forms, entries) =>
        `You have ${forms} ${forms === 1 ? "form" : "forms"} with ${entries} ${
            entries === 1 ? "entry due" : "entries due"
        }.`,
    allFormsComplete: "All your forms are complete.",
    allEntriesComplete: "All entries complete",
    entriesDueNow: (count) => `${count} entries due now`,
    completeYourEntry: (label) => `Complete your ${label.toLowerCase()} entry`,
    questionnaireDueNow: "Questionnaire due now",
    nextEntryLabel: (label) => `Next entry: ${label}`,
    waitingForNextEntry: "Waiting for next entry",
    readyLabel: (label) => `Ready: ${label}`,
    readyToComplete: "Ready to complete",
    reminderText: "We'll send you a text when it is due.",
    reminderEmail: "We'll send you an email when it is due.",
    reminderTextAndEmail: "We'll send you a text and email when it is due.",
    reminderNone: "Turn on text or email reminders in your settings if you'd like a nudge when it is due.",
    entrySubmitted: "Entry submitted.",
    completeWithCareTeam: "Complete and waiting for review.",
    formNumber: (index) => `Form #${index}`,
    dateOfProcedure: (phrase) => `Date of ${phrase}`,
    wrongDate: "Wrong date?",
    editHere: "Edit here",
    showAnswers: "Show answers",
    hideAnswers: "Hide answers",
    showAnswersDescription: "View responses, or tap Change on a timepoint to update answers",
    entryCountLabel: (count) => (count === 1 ? "1 entry" : `${count} entries`),
    timing: "Timing",
    referredBy: (name) => `Referred by: ${name}`,
    performedBy: (name) => `Performed by: ${name}`,
    method: (method) => `Method: ${method}`,
    injectionDetails: "Injection Details",
    unknown: "Unknown",
    noDateSpecified: "No Date Specified",
    noInjectionDetails: "No injection details provided.",
    sideNotSpecified: "Side not specified",
    areaNotSpecified: "Area not specified",
    siteNotSpecified: "Site not specified",
    substanceNotSpecified: "Substance not specified",
    blankAnswer: "Left blank",
    listEmptyTitle: "No Diaries Yet",
    listEmptyDescription: "Diaries created for you appear here",
    listCheckAgain: "Check Again",
    listNeedsAttention: "Needs your attention",
    listNeedsAttentionDescription: "Diaries with forms waiting for your next entry.",
    listOngoing: "Ongoing",
    listOngoingDescription: "Diaries that are in progress or waiting for your first entry.",
    listUpToDateDescription: "Diaries in progress with no entries due right now.",
    listNoOngoing: "No ongoing diaries at the moment",
    listCompletedDescription: "Diaries that have finished (no longer collecting entries).",
    listNoCompleted: "No completed diaries yet",
    listOpenDiary: "Open diary",
    listReviewDiary: "Review diary",
};
